import type { OrganizationDetail } from '@rtkwlf/eloc';
import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import { SECOND_IN_MS } from 'ae-constants/constants';

import { useElocApi } from '../use-eloc-api';

const getOrganizationDetailQueryKey = (organizationId: string) => [
  organizationId,
  'eloc',
  'get-organization-detail',
];

export const useOrganizationDetail = (
  organizationId: string,
  options?: Omit<UseQueryOptions<OrganizationDetail>, 'queryKey' | 'queryFn'>,
) => {
  const elocApi = useElocApi();

  return useQuery({
    queryFn: () => elocApi.getRendallURL({ organizationId }), // TODO: Eloc, rename getRendallURL to getOrganizationDetail
    queryKey: getOrganizationDetailQueryKey(organizationId),
    staleTime: 20 * SECOND_IN_MS,
    ...options,
  });
};
